import { api } from "@/api"

export const retrieveCashier = async (
  cashierId: string
): Promise<CashierResponse> => {
  const response = await api.get<CashierResponse>(
    `/cashiers/${cashierId}`
  )
  return response.body
}
